

/** Render a version constraint, or a dim "all versions" when empty. */
export function ConstraintCell({ value }: { value: string }) {
  if (!value || !value.trim()) {
    return <span style={{ fontSize: '0.72rem', color: 'var(--text3)' }}>all versions</span>
  }
  return <code className="mono" style={{ fontSize: '0.75rem' }}>{value}</code>
}

